import {UploadPreviewFile} from '../botato-chat-input/input-type/file-upload/upload-preview.file';

export class ClientFileMessage {

    public isError: boolean = false;

    constructor(public files: UploadPreviewFile[], public isUploading: boolean) {

    }
}
